import { render, staticRenderFns } from "./sysStudentSituationInfo.vue?vue&type=template&id=360d6452&scoped=true&"
import script from "./sysStudentSituationInfo.vue?vue&type=script&lang=js&"
export * from "./sysStudentSituationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d6452",
  null
  
)

export default component.exports